import { DateTime } from "luxon";

export const BUSINESS_TIME_ZONE = "Europe/Madrid";

export function calendarDateToBusinessEpochSeconds(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return DateTime.fromObject(
    {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    },
    { zone: BUSINESS_TIME_ZONE }
  )
    .startOf("day")
    .toSeconds();
}

export function formatBusinessDateFromEpochSeconds(epochSeconds) {
  const seconds = Number(epochSeconds);
  if (!Number.isFinite(seconds)) {
    return null;
  }

  return DateTime.fromSeconds(seconds, {
    zone: BUSINESS_TIME_ZONE,
  }).toISODate();
}
